export function addMoneyMask(value) {
  return value.toLocaleString(
    "pt-br",
    { style: "currency", currency: "BRL" }
  )
};